export default __webpack_public_path__ + "static/media/TF.dbb1ce3a.svg";